import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {makeInfoBoxControl} from '../../controls/info-box-control/info-box-control';
import {registerEmailMakerSector} from '../../right-panel-registry';

const footerInfoControl = makeInfoBoxControl({
  contentKey: 'pmwjs_email_footer_info',
});

registerEmailMakerSector(EMAIL_MAKER_COMPONENT_TYPES.misc.PMW_READ_ONLY_FOOTER, {
  title: window.i18next.t('pmwjs_footer'),
  properties: [{control: footerInfoControl}],
});
